import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Settings2 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "settings-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.32 9.37h-1.09c-.14 0-.24-.11-.3-.26a.34.34 0 010-.37l.81-.74a1.63 1.63 0 00.5-1.18 1.67 1.67 0 00-.5-1.19L18.4 4.26a1.67 1.67 0 00-2.37 0l-.77.74a.38.38 0 01-.41 0 .34.34 0 01-.22-.29V3.68A1.68 1.68 0 0013 2h-1.94a1.69 1.69 0 00-1.69 1.68v1.09c0 .14-.11.24-.26.3a.34.34 0 01-.37 0L8 4.26a1.72 1.72 0 00-1.19-.5 1.65 1.65 0 00-1.18.5L4.26 5.6a1.67 1.67 0 000 2.4l.74.74a.38.38 0 010 .41.34.34 0 01-.29.22H3.68A1.68 1.68 0 002 11.05v1.89a1.69 1.69 0 001.68 1.69h1.09c.14 0 .24.11.3.26a.34.34 0 010 .37l-.81.74a1.72 1.72 0 00-.5 1.19 1.66 1.66 0 00.5 1.19l1.34 1.36a1.67 1.67 0 002.37 0l.77-.74a.38.38 0 01.41 0 .34.34 0 01.22.29v1.09A1.68 1.68 0 0011.05 22h1.89a1.69 1.69 0 001.69-1.68v-1.09c0-.14.11-.24.26-.3a.34.34 0 01.37 0l.76.77a1.72 1.72 0 001.19.5 1.65 1.65 0 001.18-.5l1.34-1.34a1.67 1.67 0 000-2.37l-.73-.73a.34.34 0 010-.37.34.34 0 01.29-.22h1.09A1.68 1.68 0 0022 13v-1.94a1.69 1.69 0 00-1.68-1.69zM12 15.5a3.5 3.5 0 113.5-3.5 3.5 3.5 0 01-3.5 3.5z"
  }))));
});
Settings2.displayName = 'Settings2';
export var Settings2Dimensions = {
  height: 24,
  width: 24
};